import React from 'react';
import './MobileDevelopment.css';

const MobileDevelopment = () => {
  return (
    <div className="mobiledev-container">
      <div className="mobiledev-hero">
        <h1 className="mobiledev-title">Mobile App Development</h1>
        <p className="mobiledev-subtitle">
          Build smooth, scalable mobile apps for iOS and Android using Flutter, React Native, or native stacks — tailored to your product vision.
        </p>
      </div>

      <div className="mobiledev-features">
        <div className="feature-card">
          <h3>Cross-Platform Ready</h3>
          <p>Launch faster with shared codebases — Flutter and React Native deliver performance without doubling the budget.</p>
        </div>
        <div className="feature-card">
          <h3>Native Performance</h3>
          <p>We optimize animations, transitions, and APIs for speed and responsiveness across devices.</p>
        </div>
        <div className="feature-card">
          <h3>Backend Integration</h3>
          <p>Seamlessly connect your app to Firebase, Node.js, Supabase, and other cloud-based systems.</p>
        </div>
        <div className="feature-card">
          <h3>App Store Deployment</h3>
          <p>We guide you through publishing your app on Google Play and the Apple App Store with best practices and support.</p>
        </div>
      </div>

      <div className="mobiledev-cta">
        <h2>Have a Mobile App Idea?</h2>
        <p>Let our AI-powered system draft a complete project quote for your app in just a few clicks.</p>
        <button onClick={() => window.open('/project_prompt', '_blank')}>
          Generate Quotation
        </button>
      </div>
    </div>
  );
};

export default MobileDevelopment;
